import { render, staticRenderFns } from "./ApprovalRegions.vue?vue&type=template&id=2278fc48&scoped=true"
import script from "./ApprovalRegions.vue?vue&type=script&lang=js"
export * from "./ApprovalRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278fc48",
  null
  
)

export default component.exports